import { render, staticRenderFns } from "./ContentBlockList.vue?vue&type=template&id=d722407a"
import script from "./ContentBlockList.vue?vue&type=script&lang=ts"
export * from "./ContentBlockList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports